import React, { FC, useContext, useEffect } from 'react';

import { GlobalContext } from '../../../store';

import { Subheader } from '../Common/Subheader/Subheader';
import ClubRosterSection from './ClubRosterSection/ClubRosterSection';
import EventsSection from './EventsSection/EventsSection';
import { useRouteInfoState } from '../../../components/RouteInfo/Context/RouteInfo.context';

const AdminClubHome: FC = () => {
  const { clubId } = useRouteInfoState();

  const {
    actions: {
      adminEvents,
      adminClubs: { get: getAdminClubs },
      adminMemberships: { getMemberships }
    },
    adminClubs,
    adminEvents: events,
    seasons
  } = useContext(GlobalContext);

  useEffect(() => {
    if (clubId) {
      adminEvents.all(clubId).catch();
      getMemberships(String(clubId)).catch();
      getAdminClubs(clubId);
    }
  }, [clubId]);

  const club = adminClubs[Number(clubId)];
  const currentSeason = seasons[String(clubId)] && seasons[String(clubId)].currentSeason;

  return (
    <div className="admin-club-home admin-layout">
      {club && events && (
        <div>
          <Subheader clubId={club.id} profileImage={club.profileImage} title={club.name} />

          <div className="admin-wrapper">
            {currentSeason && <EventsSection />}

            <ClubRosterSection />
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminClubHome;
